<template>
  <article>
    <section class="news">
      <div class="wrapper">
        <div class="subhead">
          <span>招商赋能</span>
        </div>
        <div class="pure-g">
          <!-- @click="$router.push('/news/' + item.id)" -->
          <div class="pure-u-1 pure-u-md-1-2" v-for="(item, index) in investmentList" :key="index">
            <div class="p1-box">
              <div class="wrap">
                <img :src="'https://himifi.cn/api/admin/getImage?path=' + item.imageUrl" class="pure-img"
                  oncontextmenu="return false;">
                <p
                  style="height: 50px;line-height: 50px;background: rgba(0, 0, 0, 0.4);position: relative;margin-top: -50px;color: #ffffff;text-align: center;">
                  {{ item.imageTitle }}</p>
                <p class="list-title" v-html="item.imageContent"></p>
              </div>
            </div>
          </div>
        </div>
        <div class="subhead">
          <span>招商集锦</span>
        </div>
        <div class="p1-box">
          <div class="p0-box">
            <div class="pure-u-1 pure-u-xl-1-1">
              <video class="videoMp" controls muted loop>
                <source src="https://himifi-soft-1.oss-cn-wulanchabu.aliyuncs.com/commercialVideo/sima01.mp4"
                  type="video/mp4">
              </video>
              <video class="videoMp" style="margin-left: 10px;" controls muted loop>
                <source src="https://himifi-soft-1.oss-cn-wulanchabu.aliyuncs.com/commercialVideo/sima02.mp4"
                  type="video/mp4">
              </video>
              <video class="videoMp" style="margin-left: 10px;" controls muted loop>
                <source src="https://himifi-soft-1.oss-cn-wulanchabu.aliyuncs.com/commercialVideo/sima03.mp4"
                  type="video/mp4">
              </video>
              <video class="videoMp" style="margin-left: 10px;" controls muted loop>
                <source src="https://himifi-soft-1.oss-cn-wulanchabu.aliyuncs.com/commercialVideo/sima04.mp4"
                  type="video/mp4">
              </video>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--<section class="news">
      <div class="wrapper">
       <div class="p1-box">
        <div style="text-align:center">截至2024年8月，嗨浪名下的合伙人，单次拿货5000台的已有30多人，提车的已有约30人，这个数据还在不断增加中！</div>
        @click="$router.push('/profile/staff')"
        <div ref="mySwiper" v-swiper:mySwiper="swiperOption" class="swiper-container ygfc-swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in deliveryOf" :key="index">
              <img :src="'https://himifi.cn/api/admin/getImage?path=' + item.imageUrl" style="width: 400px;height:280px"
                oncontextmenu="return false;">
            </div>
          </div>
        </div>
      </div>
    </section> -->
  </article>
</template>

<script>
export default {
  name: "Offer",
  data() {
    return {
      investmentList: [],
      deliveryOf: [],
      curLunbo: 4,
      swiperOption: {
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        loop: true,
        breakpoints: {
          768: {  //当屏幕宽度大于等于768 
            slidesPerView: 3,
            spaceBetween: 20
          },
          1280: {  //当屏幕宽度大于等于1280
            slidesPerView: 3,
            spaceBetween: 30
          },
          1440: {  //当屏幕宽度大于等于1440
            slidesPerView: 4,
            spaceBetween: 30
          },
          1920: {  //当屏幕宽度大于等于1920
            slidesPerView: 5,
            spaceBetween: 10
          }
        }
      },
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  created() {
    //  招商赋能
    this.investment()
  },
  methods: {
    // 招商赋能
    investment() {
      this.$http.get("/website/hnWebsiteContentInfo/getList", {
        firstType: "5"
      }, res => {
        if (res.code == '200') {
          this.investmentList = res.data.招商赋能[1]
          // this.deliveryOf = res.data.提车集锦[1]
          // setInterval(() => {
          //   this.curLunbo += 1
          //   if (this.curLunbo >= this.deliveryOf.length) {
          //     this.curLunbo = 1
          //   }
          //   this.swiper.slideTo(this.curLunbo, 1000, false)
          // }, 3000)
        }
      })
    }
  }
};
</script>

<style scoped>
@import "~@/assets/styles/offer.css";

.company-detail {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.detail {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.detail>img {
  width: 50%;
}

.company-title {
  margin-top: 20px;
}

.videoMp {
  width: 24%;
}
</style>
